import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StatsInfoComponent } from "./stats-info.component";
import { CoreCommonModule } from "@core/common.module";
import { RouterModule } from "@angular/router";
import { LucideAngularModule, HardDrive, Video, Wifi, ArrowDown, ArrowUp } from "lucide-angular";

@NgModule({
  declarations: [StatsInfoComponent],
  imports: [
    CommonModule,
    CoreCommonModule,
    RouterModule,
    LucideAngularModule.pick({ HardDrive, Video, Wifi, ArrowDown, ArrowUp }),
  ],
  exports: [StatsInfoComponent],
})
export class StatsInfoModule { }
